<script setup>
/* eslint-disable */
import { ref, watch, onMounted, onUnmounted, nextTick, computed } from 'vue';
import { useRouter } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useBetBoosterStore } from '@/stores/bet_booster';
import { useInitializeStore } from '@/stores/initialize';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { useCouponsStore } from '@/stores/coupons';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import '@splidejs/vue-splide/css';

const router = useRouter();
const preSportsStore = usePreSportsStore();
const betBoosterStore = useBetBoosterStore();
const initializeStore = useInitializeStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();
const couponsStore = useCouponsStore();
const platformConfigurationStore = usePlatformConfigurationStore();

const isBetBoostsRoute = computed(() => {
	return router.currentRoute.value.name === 'pre-sports-bet-boosts';
});

const displayedSports = computed(() => {
	if (isBetBoostsRoute.value) return betBoosterStore.availableSports || [];
	return preSportsStore.preSports || [];
});

const isSportActive = (sportId) => {
	if (isBetBoostsRoute.value) {
		const currentSportId = router.currentRoute.value.params.sport_id || 'all';
		return String(sportId) === String(currentSportId);
	}
	return sportId == preSportsStore.selectedPreSportId;
};

const direction = ref(document.dir);
const splideRef = ref(null);
const options = ref({
	direction: direction.value,
	pagination: false,
	// arrows: false,
	// focus: 'center',
	autoWidth: true,
	// gap: 20,
	trimSpace: 'move'
});

const selectSport = (sport_id) => {
	window.scrollTo({ top: 0 });

	if (isBetBoostsRoute.value) {
		betBoosterStore.setSelectedSport(sport_id);
		router.push({ name: 'pre-sports-bet-boosts', params: { sport_id: sport_id } });
		return;
	}

	if (router.currentRoute.value.name == 'pre-sports-coupons-competitions') {
		router.push({name: 'pre-sports-coupons', params: {sport_id: sport_id}})
	} else if (router.currentRoute.value.name == 'pre-sports-competition') {
		router.push({name: 'pre-sports-coupons', params: {sport_id: sport_id}})
	} else if (router.currentRoute.value.name == 'pre-sports-time-coupons-competitions') {
		router.push({name: 'pre-sports-coupons', params: {sport_id: sport_id}})
	} else if (router.currentRoute.value.name == 'pre-sports-fixturebook') {
		let params = router.currentRoute.value.params;
		params.sport_id = sport_id;
		router.push({name: 'pre-sports-fixturebook', params: params})
	} else if (router.currentRoute.value.name == 'pre-sports-coupons-competitions-from-to') {
			let params = router.currentRoute.value.params;
			params.from = 'all'
			params.sport_id = sport_id;
			router.push({name: router.currentRoute.value.name, params: params.from = 'all'})

	} else {
		router.push({name: router.currentRoute.value.name, params: {sport_id: sport_id}})
	}

	if (platformConfigurationStore.isNewPreSportsLayoutEnabled) {
		couponsStore.competition_ids = [];
		dateTimeSportFiltersStore.fullyResetStore();
		document.body.classList.remove('filters-show');
	}
}

const checkArrowsVisibility = () => {
	if (splideRef.value && splideRef.value.splide) {
		const slider = splideRef.value.splide;
		let totalWidth = 0;
		slider.Components.Elements.slides.forEach(slide => {
			const marginRight = parseFloat(window.getComputedStyle(slide).marginRight);
			totalWidth += slide.offsetWidth + marginRight;
		});

		const sliderWidth = slider.Components.Elements.track.clientWidth;

		// Update arrow visibility
		slider.options = {
			...slider.options,
			arrows: totalWidth > sliderWidth
		};

		slider.refresh();
	}
};

watch(displayedSports, (newValue) => {
	if (newValue && newValue.length > 0) {
		nextTick().then(() => {
			checkArrowsVisibility();
		});
	}
}, { immediate: true });

onMounted(() => {
	window.addEventListener('resize', checkArrowsVisibility);
	if (isBetBoostsRoute.value && !betBoosterStore.bet_boosted_fixtures.length && !betBoosterStore.loading) {
		betBoosterStore.fetchBoostedBets();
	}
});

onUnmounted(() => {
	window.removeEventListener('resize', checkArrowsVisibility);
});

</script>

<template>
<div class="wrapper">
	<div id="game_slides" class="league_slides-inner">
		<!-- Slider start -->
		<Splide ref="splideRef" :options="options">
			<SplideSlide v-for="(sport, index) in displayedSports" :key="sport.id || index">
				<a @click="selectSport(sport.id)" class="league-slide-item carousel__item" :class="isSportActive(sport.id) ? 'active' : ''">
					<div class="coupon-slider-item">
						<div class="coupon-slider-content">
							<svg v-if="sport.id === 'all'" class="normal-img all-sports-rocket"
								xmlns="http://www.w3.org/2000/svg"
								style="width:20px; height:20px; fill: none; stroke: var(--white); shape-rendering:geometricPrecision;"
								viewBox="0 0 24 24"
								stroke-width="1"
								stroke-linecap="round"
								stroke-linejoin="round">
								<path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
								<path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
								<path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
								<path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
							</svg>
							<svg v-else class="normal-img"
								xmlns="http://www.w3.org/2000/svg"
								xml:space="preserve"
								version="1.1"
								style="width:23px; fill: none; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
								viewBox="0 0 30 25"
								xmlns:xlink="http://www.w3.org/1999/xlink">
								<use :xlink:href="preSportsStore.preSportWhiteIcon(sport.id) + '#svg3108'" stroke-width="1px"  />
							</svg>
							<p>{{ sport.name }}</p>
						</div>
					</div>
				</a>
			</SplideSlide>
		</Splide>
		<!-- slider end -->
	</div>
</div>
</template>
<style scoped>
@media screen and (min-width: 768px) and (max-width: 1280px) {
	a.league-slide-item.carousel__item.active p {
		color: var(--primary) !important;
	}
	a.league-slide-item.carousel__item:hover p {
		color: var(--primary) !important;
	}
}
.league-slider-main .wrapper .league_slides-inner :deep(.splide__arrow:disabled) {
	display: none !important;
}
svg.normal-img {
	stroke:var(--white)!important;
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	a.league-slide-item.carousel__item.active p {
		color: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item.active p {
		color: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item.active svg.normal-img {
		stroke: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item:hover p {
		color: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item:hover svg.normal-img {
		stroke: var(--tab-text-color-hover)!important;
	}
}
@media screen and (min-width: 1281px) and (max-width: 3000px) {
	a.league-slide-item.carousel__item.active p {
		color: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item.active p {
		color: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item.active svg.normal-img {
		stroke: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item:hover p {
		color: var(--tab-text-color-hover)!important;
	}
	a.league-slide-item.carousel__item:hover svg.normal-img {
		stroke: var(--tab-text-color-hover)!important;
	}
}
html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--prev) {
	rotate: 180deg;
	right: -10px;
	top: -3px;
	display: flex;
	left: unset;
}

html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
	rotate: 180deg;
	left: -10px;
	top: -3px;
	display: flex;
	right: unset;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}
html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrow svg) {
	rotate: 180deg;
}

html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrow) {
	background: var(--white);
}


</style>